<script setup lang="ts">
  import type { RouteLocationRaw } from 'vue-router'
  import { fmt } from '@/functions'

  defineProps<{
    icon: string,
    to?: RouteLocationRaw,
    count?: number,
    countTitle?: string,
  }>()
</script>

<template>
  <component
    :is="to ? 'router-link' : 'button'"
    :to="to"
    class="sidebar-item">
    <fa-icon
      class="sidebar-item-icon"
      :icon="icon" />
    <div class="flex-1 whitespace-nowrap font-semibold">
      <slot></slot>
    </div>
    <div
      v-if="count"
      :title="countTitle"
      class="sidebar-item-count">
      {{ fmt.number(count) }}
    </div>
  </component>
</template>
